import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

let _queryClient: QueryClient | undefined;
export const getQueryClient = () => {
  if (!_queryClient) _queryClient = new QueryClient();
  return _queryClient;
};

export const getRouter = () => {
  const queryClient = getQueryClient();
  return createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });
};
